import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import OvCompactButton from '../atoms/OvCompactButton';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';

interface OvHiddenUploadsNoticeProps {
  onViewUploads: () => void;
}

const OvHiddenUploadsNotice: FC<OvHiddenUploadsNoticeProps> = ({
  onViewUploads,
}) => {
  const { t } = useTranslation();

  return (
    <Notice>
      <span>{t('videos.uploads.hiddenByFilters')}</span>
      <OvCompactButton tone="secondary" onClick={onViewUploads}>
        {t('videos.uploads.viewUploads')}
      </OvCompactButton>
    </Notice>
  );
};

export default OvHiddenUploadsNotice;

const Notice = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${Variables.spacing.SMALL};
  font-size: ${Variables.fontSizes.SMALL};
  color: ${Colours.OV_CHARCOAL};
`;
